import { useState } from 'react';
import { Modal } from './Modal';

/**
 * Manual / preview dial (AE-10740). Preview-only campaigns force the preview step; otherwise the
 * agent can dial immediately. The BFF takes the agent and tenant from the session, so this only
 * sends the number (or a lead id, later) and the preview flag.
 */
export function ManualDial({ mode, onDial, onClose }: {
  mode: 'ALLOWED' | 'PREVIEW_ONLY';
  onDial: (b: { phone_number: string; preview: boolean }) => Promise<void>;
  onClose: () => void;
}) {
  const [number, setNumber] = useState('');
  const [busy, setBusy] = useState(false);
  const [previewed, setPreviewed] = useState<null | { phone_number: string }>(null);
  const valid = /^\+?[0-9][0-9\s()-]{6,}$/.test(number);

  const go = async (preview: boolean) => {
    setBusy(true);
    try {
      await onDial({ phone_number: number.replace(/[^0-9+]/g, ''), preview });
      if (preview) setPreviewed({ phone_number: number });
      else onClose();
    } finally { setBusy(false); }
  };

  return (
    <Modal id="manual-dial" title="Manual Dial" onClose={onClose}>
      <div className="field">
        <label>Phone number</label>
        <input id="manual-dial-number" value={number} autoFocus onChange={(e) => { setNumber(e.target.value); setPreviewed(null); }} placeholder="+1 207 555 0123" />
      </div>
      {previewed && <p className="hint">Ready to dial {previewed.phone_number}. Press Dial to connect.</p>}
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        {mode === 'PREVIEW_ONLY' && !previewed
          ? <button className="primary" id="manual-dial-preview" disabled={!valid || busy} onClick={() => go(true)}>Preview</button>
          : <button className="primary" id="manual-dial-go" disabled={!valid || busy} onClick={() => go(false)}>{busy ? 'Dialing…' : 'Dial'}</button>}
        <button onClick={onClose} disabled={busy}>Cancel</button>
      </div>
    </Modal>
  );
}
